import RadioGroupInput from './RadioGroupInput';
import CheckboxInput from './CheckboxInput';
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import DateInput from './DateInput';
import { DateTime } from 'luxon';
import type { SurveyInputProps } from './types';

const SurveyInput = ({
  control,
  name,
  type,
  options,
  validationConfig,
  togglePrompt,
}: SurveyInputProps) => {
  const isRequired = validationConfig?.isRequired || true;

  if (type === 'checkbox') {
    return (
      <CheckboxInput
        control={control}
        name={name}
        options={options}
        isRequired={isRequired}
      />
    );
  }
  if (type === 'date') {
    const { maxDateOffset, minDateOffset } = validationConfig;
    const minDate =
      minDateOffset !== undefined
        ? DateTime.now().plus({ days: minDateOffset })
        : undefined;
    const maxDate =
      maxDateOffset !== undefined
        ? DateTime.now().plus({ days: maxDateOffset })
        : undefined;
    return (
      <DateInput
        control={control}
        name={name}
        isRequired={isRequired}
        minDate={minDate}
        maxDate={maxDate}
      />
    );
  }
  if (type === 'multiselect' || type === 'select') {
    // TODO: FIX SELECTS - multi-inputs
    return (
      <SelectInput
        control={control}
        name={name}
        options={options}
        togglePrompt={togglePrompt}
        isMultiple={type === 'multiselect'}
        isRequired={isRequired}
      />
    );
  }
  if (type === 'radio') {
    return (
      <RadioGroupInput
        control={control}
        name={name}
        options={options}
        togglePrompt={togglePrompt}
        isRequired={isRequired}
      />
    );
  }
  return (
    <TextInput
      control={control}
      name={name}
      isRequired={isRequired}
      isMultiline={type === 'textarea'}
    />
  );
};

export default SurveyInput;
